import React from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.tsx';
import { FaHome, FaCalendarAlt, FaPlus, FaTicketAlt, FaUser, FaChartBar } from 'react-icons/fa';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [mounted, setMounted] = React.useState(false);
  
  React.useEffect(() => {
    setMounted(true);
  }, []);
  
  const isActive = (href: string) => location.pathname === href;

  const navItems = [
    { to: '/events', label: 'Events', icon: FaCalendarAlt },
    ...(user?.role === 'PROMOTER' ? [{ to: '/promoter/dashboard', label: 'Dashboard', icon: FaChartBar }] : 
        user?.role === 'ORGANIZER' ? [{ to: '/organizer/dashboard', label: 'Dashboard', icon: FaChartBar }] : 
        [{ to: '/sell-ticket', label: 'List', icon: FaPlus }]),
    { to: '/', label: 'Home', icon: FaHome },
    ...(user ? [{ to: '/my-tickets', label: 'My Tickets', icon: FaTicketAlt }] : []),
    { to: user ? '/profile' : '/login', label: 'Account', icon: FaUser }
  ];

  const navContent = (
    <nav 
      className="mobile-bottom-nav md:hidden"
      style={{
        position: 'fixed',
        // Use safe area in bottom position for iOS - this ensures it stays at physical bottom
        bottom: 'env(safe-area-inset-bottom, 0px)',
        left: 0,
        right: 0,
        zIndex: 99999,
        width: '100%',
        maxWidth: '100vw',
        // No transforms - they create a containing block on iOS Safari
        // Prevent any parent from affecting it
        isolation: 'isolate'
      }}
    >
      <div className="flex items-center justify-around px-2 py-2" style={{ height: '72px' }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.to);
          
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center py-2 px-2 sm:px-3 rounded-lg transition-all duration-200 min-w-0 flex-1 ${
                active 
                  ? 'text-[#D6A77A] bg-[#F5E7D6]' 
                  : 'text-gray-600 hover:text-[#D6A77A] hover:bg-[#F5E7D6]'
              }`}
              aria-label={item.label}
            >
              <Icon className={`text-lg sm:text-xl mb-1 ${active ? 'scale-110' : ''} transition-transform duration-200`} />
              <span className={`text-xs font-medium truncate ${active ? 'font-semibold' : ''}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );

  if (!mounted) return null;

  // Render directly to body to avoid any parent container positioning issues
  return createPortal(navContent, document.body);
};

export default MobileBottomNav; 